<div
  class="rail"
  [class.rail--compact]="compact"
  role="img"
  [attr.aria-label]="'Status: ' + status"
>
  @for (s of statuses; track s; let i = $index; let last = $last) {
    <div class="rail-step">
      <div class="rail-node" [ngClass]="'rail-node--' + state(i)">
        @if (state(i) === 'done') {
          <mat-icon class="rail-icon">check</mat-icon>
        } @else if (state(i) === 'current') {
          <span class="rail-node-dot" aria-hidden="true"></span>
        }
      </div>

      @if (!compact) {
        <span class="rail-label" [ngClass]="'rail-label--' + state(i)">{{ s }}</span>
      }
    </div>

    @if (!last) {
      <div
        class="rail-connector"
        [ngClass]="{ 'rail-connector--filled': state(i) === 'done' }"
      ></div>
    }
  }
</div>
